__turbopack_context__.v({
  "body": "_f8b2a_body",
  "copy": "_f8b2a_copy",
  "copyColumn": "_f8b2a_copyColumn",
  "findStore": "_f8b2a_findStore",
  "globeBleed": "_f8b2a_globeBleed",
  "globeFade": "_f8b2a_globeFade",
  "globeMedia": "_f8b2a_globeMedia",
  "globeMediaReady": "_f8b2a_globeMediaReady",
  "globeSnapshot": "_f8b2a_globeSnapshot",
  "globeSnapshotFaded": "_f8b2a_globeSnapshotFaded",
  "globeStage": "_f8b2a_globeStage",
  "inner": "_f8b2a_inner",
  "outer": "_f8b2a_outer",
  "stat": "_f8b2a_stat",
  "statLabel": "_f8b2a_statLabel",
  "statValue": "_f8b2a_statValue",
  "stats": "_f8b2a_stats",
  "title": "_f8b2a_title",
});
